<template>
    <a
        v-if="isExternalLink"
        :href="slideLink"
        :target="target"
        rel="noopener noreferrer"
        class="profit-propositions-box relative offer-slide"
    >
        <nuxt-img
            :src="slideImg.src"
            alt="Баннер"
            class="profit-propositions-box__img"
        />
        <div class="profit-propositions-box__content relative">
            <div>
                <h4
                    v-if="slideTitle.title"
                    :class="[
                        'profit-propositions-box__title',
                        ...(slideTitle?.additionalClasses ?? [])
                    ]"
                    v-html="slideTitle.title"
                />
                <div
                    v-if="slideValue"
                    class="profit-proposition-box__descr-wrapp"
                >
                    <p
                        :class="['profit-propositions-box__desc', slideValue.classes]"
                        v-html="slideValue.value"
                    />
                </div>
            </div>
        </div>
    </a>
    <n-link
        v-else
        :to="slideLink"
        class="profit-propositions-box relative offer-slide"
    >
        <nuxt-img
            :src="slideImg.src"
            alt="Баннер"
            class="profit-propositions-box__img"
        />
        <div class="profit-propositions-box__content relative">
            <div>
                <h4
                    v-if="slideTitle.title"
                    :class="[
                        'profit-propositions-box__title',
                        ...(slideTitle?.additionalClasses ?? [])
                    ]"
                    v-html="slideTitle.title"
                />
                <div
                    v-if="slideValue"
                    class="profit-proposition-box__descr-wrapp"
                >
                    <p
                        :class="['profit-propositions-box__desc', slideValue.classes]"
                        v-html="slideValue.value"
                    />
                </div>
            </div>
        </div>
    </n-link>
</template>

<script>
import {computed, defineComponent} from 'vue';

export default defineComponent({
    name: 'SlideItem',
    props: {
        slideImg: {
            type: [Object, String],
            required: true,
        },
        slideTitle: {
            type: Object,
            default: () => null,
        },
        slideLink: {
            type: String,
            default: () => '',
        },
        slideValue: {
            type: Object,
            default: () => null,
        },
        slideAddition: {
            type: Object,
            default: () => null,
        },
        mainSlide: {
            type: Boolean,
            default: () => false,
        },
        target: {
            type: String,
            default: () => '_blank',
        },
    },
    setup(props) {
        const isExternalLink = computed(() => {
            if (!props.slideLink.startsWith('/') || props.slideLink.includes('cabinet')) {
                return true;
            }

            return false;
        });

        return {
            backgroundModifiers: {
                format: 'webp',
                loading: 'lazy',
            },
            isExternalLink,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/home-page/index/profit-propositions';
</style>
